import React from 'react';
import AboutOverviewPage from './AboutOverviewPage';
import { ABOUT_OVERVIEW } from './aboutOverviewData';

const About = () => (
  <AboutOverviewPage
    data={ABOUT_OVERVIEW}
    versionLink={{ to: '/about/v2', label: 'View Version 2.0.0 →' }}
  />
);

export default About;
